/*
 * Anchors the tab overflow menu below and flush-right of its trigger button.
 * viewportWidth must be document.documentElement.clientWidth, not window.innerWidth -
 * innerWidth includes the vertical scrollbar, but the fixed menu's right containing
 * block does not, which put the menu ~15px off on desktop.
 */
export const getTabMenuAnchor = (
    rect: { bottom: number; right: number },
    viewportWidth: number
): { top: number; right: number } => ({
    top: rect.bottom,
    right: Math.max(viewportWidth - rect.right, 0)
});
